module.exports = __webpack_public_path__ + "static/Larsseit-Regular-154b7206ceece4527a60933f79dd4b6a.otf";